import React from "react";
import { CRMEmptyPlaceholder } from "../Simple/CRMEmptyPlaceholder/CRMEmptyPlaceholder";
import { Background } from "../BuildingBlocks/Background";
import { CRMSpacing } from "../../models/CRMSpacing";
// CRMReportTable.scss is bundled by the scss build pipeline — do NOT import it here (esbuild has no SCSS loader and the import breaks the web bundle).

type TCRMReportTableProps = {
    headers: Array<string>;
    rows: Array<Record<string, unknown>>;
};

const formatCell = (value: unknown): string => {
    if (value === null || value === undefined || value === "") {
        return "—";
    }
    if (typeof value === "boolean") {
        return value ? "Yes" : "No";
    }
    return String(value);
};

export const CRMReportTable = (props: TCRMReportTableProps): JSX.Element => {
    if (props.rows.length === 0) {
        return (
            <Background padding={`${CRMSpacing.X_LARGE} ${CRMSpacing.LARGE}`}>
                <CRMEmptyPlaceholder iconSize="70px" textGap={CRMSpacing.TINY}>
                    No rows for this report and period.
                </CRMEmptyPlaceholder>
            </Background>
        );
    }

    return (
        <div className="crm-report-table-wrap">
            <table className="crm-report-table">
                <thead>
                    <tr>
                        {props.headers.map((header) => (
                            <th key={header} className="crm-report-table__th">{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {props.rows.map((row, rowIndex) => (
                        <tr key={rowIndex} className="crm-report-table__tr">
                            {props.headers.map((header) => (
                                <td key={header} className="crm-report-table__td">{formatCell(row[header])}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
